export default class TagStates {
    public static readonly Active: TagStatesType = "Active";                 // tag is still active
    public static readonly Deleted: TagStatesType = "Deleted";               // tag has been deleted
}

export type TagStatesType = "Active" | "Deleted";